import script from "./ProjectProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ProjectProgressBar.vue?vue&type=style&index=0&id=87973448&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87973448"]])

export default __exports__